export default __webpack_public_path__ + "static/media/ankleSagittalMovement.9ca6a7e8.png";